// **********************************************************
// Location Popup
// **********************************************************

attachEvent('.location-popup__nav-item.has-dropdown .location-popup__link', 'click', (ev) => {
  const parentElem = ev.target.closest('.location-popup__nav-item');
  const mainParent = parentElem.closest('.location-popup');
  const dropdownContent = parentElem.querySelector('.location-popup__dropdown-inner');
  parentElem.classList.add('is-active');
  mainParent.classList.add('is-items-open');

  dropdownContent.scrollTo({
    top: 0,
  });
});

attachEvent('.location-popup__back-button', 'click', (ev) => {
  const parentElem = ev.target.closest('.location-popup__nav-item.is-active');
  const mainParent = parentElem?.closest('.location-popup.is-items-open');
  parentElem?.classList.remove('is-active');
  mainParent?.classList.remove('is-items-open');
  mainParent?.querySelectorAll('.is-active').forEach((ele) => ele.classList.remove('is-active'));
});

attachEvent('.store-map__popup-trigger', 'click', (ev) => {
  const parentElem = ev.target.closest('.store-map__popup-wrapper');
  const mainParent = parentElem.querySelector('.location-popup');
  mainParent.classList.add('is-open');
});

attachEvent('.location-popup__close', 'click', (ev) => {
  const parentElem = ev.target.closest('.store-map__popup-wrapper');
  const mainParent = parentElem.querySelector('.location-popup.is-open');
  mainParent.classList.remove('is-open');
});

attachEvent('.location-popup__not-found-back', 'click', (ev) => {
  const mainParent = ev.target.closest('.location-popup.no-result-found');
  mainParent?.classList.remove('no-result-found');
});
